module.exports = __webpack_public_path__ + "static/32-fca782b7dc25742e6162d91aad486800.png";